import { AutomobileOwnershipHistory } from '@/reports/types/vehicles';
import { Divider, Pill, Stack, Text, styled } from '@/theme/index';
import { commaFormat, commaFormatCurrency, DateUtil } from '@/utils/index';

export const StyledPill = styled(Pill)(({ theme }) => ({
  borderRadius: '0.25rem',
  backgroundColor: theme.palette.grey[300],
  fontSize: '0.875rem',
}));

export const CardImage = styled('img')(() => ({
  width: '1.5rem',
  height: '1.5rem',
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const CardTitleText = ({
  vehicleOwnershipHistory,
}: {
  vehicleOwnershipHistory: AutomobileOwnershipHistory;
}): JSX.Element => {
  const parsedDate = new DateUtil().parseDateFromString(
    vehicleOwnershipHistory.data_date?.full || '',
    'MM/yyyy'
  );
  const cityState = [
    vehicleOwnershipHistory.owner_address?.parsed?.city,
    vehicleOwnershipHistory.owner_address?.parsed?.state,
  ]
    .filter(Boolean)
    .join(', ');
  return (
    <Text fontSize="1rem">
      Purchased
      <Text component="span" fontWeight="bold">
        {' '}
        {vehicleOwnershipHistory.is_new ? 'New' : 'Used'}
      </Text>
      {parsedDate ? (
        <>
          {' '}
          in
          <Text component="span" fontWeight="bold">
            {' '}
            {parsedDate}
          </Text>
        </>
      ) : (
        ''
      )}
      {cityState ? (
        <>
          {' '}
          in
          <Text component="span" fontWeight="bold">
            {' '}
            {cityState}
          </Text>
        </>
      ) : (
        ''
      )}
    </Text>
  );
};

export const CardDetails = ({
  vehicleOwnershipHistory,
}: {
  vehicleOwnershipHistory: AutomobileOwnershipHistory;
}): JSX.Element => {
  const sellerLocation = [
    vehicleOwnershipHistory.seller_address?.parsed?.city,
    vehicleOwnershipHistory.seller_address?.parsed?.state,
  ]
    .filter(Boolean)
    .join(', ');

  const items = [
    {
      title: 'Purchased for:',
      value: vehicleOwnershipHistory.price
        ? commaFormatCurrency(vehicleOwnershipHistory.price)
        : '-',
    },
    {
      title: 'Purchased from:',
      value: vehicleOwnershipHistory.seller
        ? `${vehicleOwnershipHistory.seller} ${
            sellerLocation ? `in ${sellerLocation}` : ''
          }`
        : '-',
    },
    {
      title: 'Mileage at purchase:',
      value: vehicleOwnershipHistory.odometer
        ? commaFormat(parseInt(vehicleOwnershipHistory.odometer || ''))
        : '-',
    },
    {
      title: 'Lien Holder:',
      value: vehicleOwnershipHistory.lien_holder || '-',
    },
  ];

  return (
    <Stack spacing={2} direction="column">
      {items.map((item) => {
        return (
          <Stack spacing={0} direction="column" key={item.title}>
            <Text fontSize="0.875rem">{item.title}</Text>
            <Text fontSize="0.875rem" fontWeight="bold">
              {item.value}
            </Text>
          </Stack>
        );
      })}
    </Stack>
  );
};
